module.exports = __webpack_public_path__ + "assets/img/like.a99f2b1e.png";